const SEOHeading = ({ level = 1, children, className, id, ...props }) => {
  // Ensure valid heading level
  const validLevel = Math.max(1, Math.min(6, level));
  const HeadingTag = `h${validLevel}`;
  
  // Auto-generate ID from text content if not provided
  const headingId = id || (typeof children === 'string' 
    ? children.toLowerCase().replace(/[^a-z0-9]+/g, '-')
    : undefined);

  return (
    <HeadingTag id={headingId} className={className} {...props}>
      {children}
    </HeadingTag>
  );
};

export default SEOHeading; 